import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { useAuth } from '../context/AuthContext';
import { STARTER_CATEGORIES } from '../data/starterDecks';
import { createNewCardState } from '../data/fsrs';
import db from '../data/db';
import AuthScreen from './AuthScreen';
import { FiGlobe, FiCpu, FiHeart, FiBook, FiCode } from 'react-icons/fi';

const ICONS = {
  globe: <FiGlobe />,
  beaker: <FiCpu />,
  code: <FiCode />,
  heart: <FiHeart />,
  book: <FiBook />,
};

export default function Onboarding() {
  const [step, setStep] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState(false);
  const { completeOnboarding } = useApp();
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  async function handleSelectCategory(category) {
    setSelectedCategory(category.id);
    setLoading(true);

    const deck = category.decks[0];
    const deckId = await db.decks.add({
      name: deck.name,
      description: deck.description,
      emoji: deck.emoji,
      createdAt: new Date().toISOString(),
      cardCount: deck.cards.length,
    });

    const cardEntries = deck.cards.map(card => ({
      deckId,
      front: card.front,
      back: card.back,
      fsrs: createNewCardState(),
      createdAt: new Date().toISOString(),
    }));

    await db.cards.bulkAdd(cardEntries);
    await completeOnboarding();

    setTimeout(() => {
      navigate(`/study/${deckId}`);
    }, 600);
  }

  function handleSkipAuth() {
    setStep(2);
  }

  return (
    <div className="onboarding">
      <div className="onboarding-content">
        {step === 0 && (
          <div className="onboarding-welcome fade-in">
            <div className="onboarding-logo">
              <span className="logo-icon">⚡</span>
            </div>
            <h1>Welcome to <span className="text-gradient">Recall</span></h1>
            <p className="onboarding-subtitle">
              Master anything with the science of spaced repetition.
              Beautiful. Powerful. Effective.
            </p>
            <button className="btn btn-primary btn-lg" onClick={() => setStep(1)}>
              Get Started
            </button>
            <p className="onboarding-hint">You'll be studying in under 60 seconds</p>
          </div>
        )}

        {step === 1 && !isAuthenticated && (
          <div className="fade-in">
            <AuthScreen onSkip={handleSkipAuth} />
          </div>
        )}

        {(step === 2 || (step === 1 && isAuthenticated)) && (
          <div className="onboarding-categories fade-in">
            <h2>What do you want to learn?</h2>
            <p className="onboarding-subtitle">Pick a topic and start studying immediately</p>
            <div className="category-grid">
              {STARTER_CATEGORIES.map(category => (
                <button
                  key={category.id}
                  className={`category-card ${selectedCategory === category.id ? 'selected' : ''}`}
                  onClick={() => handleSelectCategory(category)}
                  disabled={loading}
                >
                  <div className="category-icon">{ICONS[category.icon]}</div>
                  <h3>{category.name}</h3>
                  <p>{category.description}</p>
                  {selectedCategory === category.id && loading && (
                    <div className="category-loading">
                      <div className="spinner" />
                    </div>
                  )}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
